<div class="spinner-box">
    <div class="three-quarter-spinner"></div>
</div>
